module.exports = __webpack_public_path__ + "201811/img/member_level_1.08d92bfe.png";